import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
  textField: {
    width: "100%",
    height: "45px",
    fontSize: "14px",
    fontFamily: "Muli",
    color: "#929090",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
  },
  icon: {

    marginTop: "5px"
  },
  label: {
    marginLeft: 8,
    marginRight: 8,
    //width: "50px",
    fontSize: "15px"
  },
  formControl: {
    width: "355px",
    height: "45",
    borderradius: "4px",
    backgroundcolor: "#ffffff",
    //minWidth: 120,
    "& label.Mui-focused": {
      color: "#646BDB",

    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#646BDB"
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#D6D6D6"
      },
      "&:hover fieldset": {
        borderColor: "#929090",
        color: "#929090"
      },
      "&.Mui-focused fieldset": {
        borderColor: "#646BDB"
      }
    }
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  }
}));
export default function CustomSelectWithDescription(props) {
  const classes = useStyles();
  const inputLabel = React.useRef(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);
  const handleChange = event => {
    props.onSelect(event.target.value);
  };
  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel
        ref={inputLabel}
        className={classes.label}
        id="demo-simple-select-outlined-label"
      >
        {props.label}
      </InputLabel>
      <Select
        native
        id="demo-simple-select-outlined"
        labelId="demo-simple-select-outlined-label"
        className={classes.textField}
        value={props.value}
        onChange={handleChange}
        labelWidth={labelWidth}
        classes={{ icon: classes.icon }}
        disabled={props.disabled}
      >
        <option key="-1" value="" />
        {props.options.map((key, index) => (
          <optgroup key={index} label={Object.keys(key)[0]} >
            {key[Object.keys(key)[0]].map((data, i) => (
              <option key={i} value={data.value}>{data.label}</option>
            ))}
          </optgroup>
        ))}
      </Select>
    </FormControl>
  );
}
